import VSelectTeacher from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectTeacher', VSelectTeacher),
};
